/* custom implementation with intersection observer + native css scroll snapping
 * cuz browsers are better now */ 

import jQuery from 'jquery';
window.$ = jQuery;

const ul = document.createElement("UL");

ul.setAttribute("class", "pagination");
ul.setAttribute("style", "z-index:997;");

const videoSection = document.querySelector('.video-section');
if (videoSection) {
  document.querySelector(".play-button").addEventListener("keyup", _handleKey);
  document.querySelector("video").addEventListener("keyup", _handleKey);
}

const imageSections = $(".image-section");
imageSections.each(function(i) {
  const a = document.createElement("A");
  const j = videoSection ? i + 1 : i;
  const li = document.createElement("LI");

  //li.setAttribute("id", `${j + 1}`);
  a.setAttribute("href", `#${j + 1}`);
  a.setAttribute("data-index", `${j}`);
  a.setAttribute("aria-hidden", `true`);
  a.setAttribute("tabindex", `-1`);
  a.style.setProperty('--imageSectionsLength', `${imageSections.length}`);

  li.append(a);
  ul.append(li);
});

const scrollContainer = document.querySelector('.images-section');
if (scrollContainer) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio >= 0.99) {
        entry.target.classList.add('fully-visible');
      } else {
        entry.target.classList.remove('fully-visible');
      }
    });
  }, { threshold: [0.99] });

    observer.observe(scrollContainer);
   // $('.images-section').before(ul);

  const slides = document.querySelectorAll('.slide-wrapper'); 
  const paginationDots = document.querySelectorAll('.pagination a'); 
  paginationDots[0]?.classList.add("active");
  let currentSlideIndex = 0;

  const slideObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Find the index of the currently visible slide
        const slideIndex = Array.from(slides).indexOf(entry.target);
        
        if (slideIndex !== currentSlideIndex) {
          // Remove active class from previous dot
          paginationDots[currentSlideIndex]?.classList.remove('active');
          
          // Add active class to current dot
          paginationDots[slideIndex]?.classList.add('active');
          
          currentSlideIndex = slideIndex;
        }
      }
    });
  }, {
    root: document.querySelector('.scroll-container'), // Your scroll container
    threshold: 0.5 // Trigger when 50% of slide is visible
  });

  // Observe all slides
  slides.forEach(slide => slideObserver?.observe(slide));
}
